import React, { ReactElement } from 'react'

export const VerticalSplit: React.FC = (): ReactElement => (
    <div className='layout-vertical-split'>
        <svg viewBox='0 0 30 30'>
            <path className='dashboard-layout-outer-border' d='M28,2V28H2V2H28m2-2H0V30H30V0Z' />
            <line className='central-border-line' x1='15' x2='15' y2='30' />
            <rect className='dashboard-background-1 dashboard-layout-entry-square' x='2' y='2' width='12' height='26' />
            <text className='dashboard-foreground-1 dashboard-layout-entry-text' transform='translate(6.64 17.69)'>
                1
            </text>
            <rect
                className='dashboard-background-2 dashboard-layout-entry-square'
                x='16'
                y='2'
                width='12'
                height='26'
            />
            <text className='dashboard-foreground-2 dashboard-layout-entry-text' transform='translate(20.2 17.69)'>
                2
            </text>
        </svg>
    </div>
)
